import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { AlertDialogTypeEnum, AlertDialogConfirmTypeEnum } from '../../_enums/_index';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.css']
})
export class AlertDialogComponent implements OnInit {

    message: string;
    dialogHeader: string;
    alertDialogType: AlertDialogTypeEnum;
    alertDialogConfirmType: AlertDialogConfirmTypeEnum;
    private confirmMessage: string;
    private confirmCancelMessage: string;

    constructor(public dialogRef: MatDialogRef<AlertDialogComponent>) {
    }

    ngOnInit() {
        
    }

    getIcon() {
        switch (this.alertDialogType) {
            case AlertDialogTypeEnum.Confirm:
                return "fa-question-circle";
            case AlertDialogTypeEnum.Warning:
                return "fa-exclamation-triangle";
            case AlertDialogTypeEnum.Information:
                return "fa-info-circle";

                
        }
    }

    isConfirmDialog() {
        return this.alertDialogType == AlertDialogTypeEnum.Confirm;
    }

    okClick() {
        this.dialogRef.close(true);
    }

    cancelClick() {
        this.dialogRef.close(false);
    }

    getConfirmMessage()
    {
        if (this.alertDialogType == AlertDialogTypeEnum.Confirm)
        {
            if (this.alertDialogConfirmType == AlertDialogConfirmTypeEnum.OkCancel)
                return "אישור";
            return "כן";
        }
        return "אישור";
    }

    getCancelMessage() {

        if (this.alertDialogConfirmType == AlertDialogConfirmTypeEnum.OkCancel)
            return "ביטול";
        return "לא";

    }
}



// WEBPACK FOOTER //
// ./src/app/components/alert-dialog/alert-dialog.component.ts